import React, { PureComponent } from "react";
import { Tooltip, message } from "antd";
import { Spring } from "react-spring";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const tools = [
  { icon: "download", description: "Download" },
  { icon: "star", description: "Save" },
  // { icon: "search-plus", description: "Inspect" },
];
export default class Thumbnail extends PureComponent {
  state = { hover: false, saved: false, magnify: false };

  handleToolClick = async tool => {
    // add transition on click in Future
    switch (tool) {
      case "download":
        downloadFile(this.props.file, this.props.image_id);
        break;
      case "star":
        if (!this.props.auth) return message.error("Please log in to save textures");
        const res = await axios.post("/api/save_image", {
          image_id: this.props.image_id,
        });
        if (res.status === 200) message.success("Texture saved!");
        this.setState({ saved: true });
        break;
      case "zoom-in":
        break;
      default:
    }
    return null;
  };

  renderTools = () => {
    const { hover } = this.state;
    if (!hover) return null;
    return (
      <Spring
        from={{ right: "-1em", color: "hsla(0, 0, 1, 0)" }}
        to={{ right: "1em", color: "hsla(0, 0, 1, 0.65)" }}
      >
        {({ right, color }) => (
          <div
            style={{
              textShadow: "2px 2px 3px  black",
              color,
              position: "absolute",
              right,
              bottom: "1em",
              zIndex: 100,
            }}
          >
            {tools.map(tool => (
              <Tooltip placement="bottomLeft" key={tool.icon} title={tool.description}>
                <FontAwesomeIcon
                  className="tools"
                  // theme={
                  //   tool.icon === "star" && this.state.saved ? "twoTone" : ""
                  // }
                  // twoToneColor="gold"
                  style={{
                    cursor: "pointer",
                    fontSize: "2em",
                    filter: "drop-shadow(1px 1px 2px rgba(0,0,0,1))",
                    margin: 2,
                    color: tool.icon === "star" && this.state.saved ? "gold" : "#ffffff78",
                  }}
                  icon={tool.icon}
                  onClick={() => this.handleToolClick(tool.icon)}
                />
              </Tooltip>
            ))}
          </div>
        )}
      </Spring>
    );
  };

  render() {
    const { width, height, url, gutter, onClick, file, hasChildren, texture } = this.props;
    const { hover } = this.state;
    return (
      <Spring
        to={{
          scale: hover ? 0.95 : 1,
        }}
        toggle={hover} // Additional props will be spread over the child
      >
        {({ scale }) => (
          <div
            style={{
              transform: `scale(${scale}) translateZ(0)`,
              cursor: "pointer",
              height: "100%",
              userSelect: "none",
              width: width + gutter,
              position: "relative",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              WebkitTransform: "translateZ(0)",
            }}
            onMouseEnter={() => this.setState({ hover: true })}
            onMouseLeave={() => this.setState({ hover: false })}
          >
            {hasChildren && (
              <Tooltip title={`Multiple Images(${hasChildren.length + 1})`}>
                <div
                  onClick={() => onClick(texture)}
                  style={{
                    zIndex: 102,
                    position: "absolute",
                    left: "1em",
                    top: "1em",
                  }}
                >
                  <FontAwesomeIcon className="hvr-grow" size="4x" icon="images" />
                </div>
              </Tooltip>
            )}
            {this.renderTools()}
            {/* <div
          style={{
            color: "black",
            fontSize: 36,
            background: "#ff0000a6",
            width,
            height,
            marginRight: gutter
          }}
        >
          {height}
        </div> */}
            {hover && (
              <Spring from={{ opacity: "0" }} to={{ opacity: "0.65" }}>
                {({ opacity }) => (
                  <div
                    style={{
                      position: "absolute",
                      pointerEvents: "none",
                      left: 0,
                      width,
                      height,
                      background: `linear-gradient(to top, rgba(0,0,0,${opacity}) 0%,rgba(0,0,0,0) 50%,rgba(0,0,0,0) 100%)`,
                    }}
                  />
                )}
              </Spring>
            )}
            <img
              onClick={() => onClick(texture)}
              alt={file}
              style={{
                width,
                height,
                marginRight: gutter,
              }}
              src={url}
            />
          </div>
        )}
      </Spring>
    );
  }
}

function downloadFile(filename, id) {
  const downloadUrl = "https://texture-ninja.nyc3.cdn.digitaloceanspaces.com/";
  const url = downloadUrl + filename;
  const tempLink = document.createElement("a");
  tempLink.style.display = "none";
  tempLink.href = url;
  tempLink.setAttribute("download", filename);

  // Safari thinks _blank anchor are pop ups. We only want to set _blank
  // target if the browser does not support the HTML5 download attribute.
  // This allows you to download files in desktop safari if pop up blocking
  // is enabled.
  if (typeof tempLink.download === "undefined") {
    tempLink.setAttribute("target", "_blank");
  }

  document.body.appendChild(tempLink);
  tempLink.click();
  document.body.removeChild(tempLink);
  // window.URL.revokeObjectURL(blobURL);
  axios.post("/api/download_image", { id });
}



// WEBPACK FOOTER //
// ./src/components/gallery/Thumbnail.js